import { render } from "./RollUp.vue?vue&type=template&id=08539b91"
import script from "./RollUp.vue?vue&type=script&lang=js"
export * from "./RollUp.vue?vue&type=script&lang=js"

import "./RollUp.vue?vue&type=style&index=0&id=08539b91&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__